import * as core from '../../../../../../../core'
import * as prebuilt from '../../../../../../prebuilt'
import * as space from '../space'

export const RESOURCE = {
  payload: {
    alias: 'space:service-centers',
    appAlias: space.RESOURCE.payload.alias,
    description: 'Service Centers page',
    display: {
      isMain: false,
      position: 1,
    },
    name: 'Service Centers',
    page: { id: prebuilt.Page.Id.SpaceServiceCenters },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
